import http from '@/utils/http';
import { DEVICE, IDENTITY_KEY_NAME } from '@/constants';
import {
  getIdentity,
  osDetect,
  callNativeFunction, nativeFunction,
} from '@/utils/detectDevice';

const post = (params) => {
  const id = getIdentity(IDENTITY_KEY_NAME.UID, 0);
  if (id > 0) {
    (osDetect() !== DEVICE.IOS)
      ? http.apiPost(`../statistic/input/behavior/${id}/library`, params)
      : callNativeFunction(nativeFunction.USE_NATIVE_POST)(params);
  }
};

export default {
  post,
};
